/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/colonization': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 8.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5z"/><path pid="1" d="M16 4C9.371 4 4 9.372 4 16s5.371 12 12 12 12-5.372 12-12S22.629 4 16 4zm.5 12.449V26h-1v-9.551c-2.244-.252-4-2.139-4-4.449 0-2.481 2.019-4.5 4.5-4.5 2.48 0 4.5 2.019 4.5 4.5 0 2.31-1.756 4.197-4 4.449z"/><path pid="2" d="M16 32C7.178 32 0 24.822 0 16S7.178 0 16 0s16 7.178 16 16-7.178 16-16 16zm0-30C8.28 2 2 8.28 2 16s6.28 14 14 14c7.721 0 14-6.28 14-14S23.721 2 16 2z"/>'
  }
})
